var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsitesNewsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "websites-news-icon_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 70.87"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".websites-news-icon_svg__cls-2{stroke:#010101;stroke-miterlimit:10;stroke-width:2px;fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.63 33.05c1.16 11.7-8.59 21.45-20.29 20.29-8.66-.86-15.66-7.86-16.52-16.52-1.16-11.7 8.59-21.45 20.29-20.29 8.66.86 15.66 7.86 16.52 16.52z",
    fill: "#f9d8cd",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "websites-news-icon_svg__cls-2",
    d: "M15.03 27.95h5.59v11.17h-5.59c-3.07 0-5.59-2.49-5.59-5.59 0-3.1 2.49-5.59 5.59-5.59z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    fill: "#e84b0f",
    d: "M20.61 27.95h5.59v11.17h-5.59z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.61 39.12h5.59v5.56c0 3.1-2.52 5.59-5.59 5.59h0V39.13h0z",
    fill: "#e9eaeb",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "websites-news-icon_svg__cls-2",
    d: "M42.96 44.68L26.2 39.12V27.95l16.76-5.56v22.29zM48.28 33.54h14.15M48.28 25.16l14.15-5.56M48.28 41.89l14.15 5.58"
  })));
}
export default SvgWebsitesNewsIcon;